/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../../addresses/Addresses.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationWebsitesDetailsBox_OrganisationProfileFragment = { __typename: 'OrganisationProfile', id: string, slug: string, categories: Array<string>, contactEmail?: any | null, contactWebsite?: string | null, contactAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, contactPhones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }> };

export type OrganisationWebsitesDetailsBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, email: any, website: string, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }>, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null };

export type OrganisationWebsitesDetailsBox_ModifyProfileMutationVariables = Types.Exact<{
  input: Types.ModifyOrganisationProfileInput;
}>;


export type OrganisationWebsitesDetailsBox_ModifyProfileMutation = { modifyOrganisationProfile: { __typename: 'ModifyOrganisationProfileResult', profile: { __typename: 'OrganisationProfile', id: string, categories: Array<string>, contactEmail?: any | null, contactWebsite?: string | null, contactAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, contactPhones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }> } } };

export const OrganisationWebsitesDetailsBox_OrganisationProfileFragmentDoc = gql`
    fragment OrganisationWebsitesDetailsBox_OrganisationProfile on OrganisationProfile {
  id
  slug
  categories
  contactAddress {
    ...AddressDetails__Address
  }
  contactEmail
  contactPhones {
    id
    number
    type
    main
  }
  contactWebsite
}
    ${AddressDetails__AddressFragmentDoc}`;
export const OrganisationWebsitesDetailsBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationWebsitesDetailsBox_ViewerOrganisation on ViewerOrganisation {
  id
  categories
  email
  website
  phones {
    id
    number
    type
    main
  }
  branchAddress {
    ...AddressDetails__Address
  }
  billingAddress {
    ...AddressDetails__Address
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export const OrganisationWebsitesDetailsBox_ModifyProfileDocument = gql`
    mutation OrganisationWebsitesDetailsBox_ModifyProfile($input: ModifyOrganisationProfileInput!) {
  modifyOrganisationProfile(input: $input) {
    profile {
      id
      categories
      contactAddress {
        ...AddressDetails__Address
      }
      contactEmail
      contactPhones {
        id
        number
        type
        main
      }
      contactWebsite
    }
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export type OrganisationWebsitesDetailsBox_ModifyProfileMutationFn = Apollo.MutationFunction<OrganisationWebsitesDetailsBox_ModifyProfileMutation, OrganisationWebsitesDetailsBox_ModifyProfileMutationVariables>;

/**
 * __useOrganisationWebsitesDetailsBox_ModifyProfileMutation__
 *
 * To run a mutation, you first call `useOrganisationWebsitesDetailsBox_ModifyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationWebsitesDetailsBox_ModifyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationWebsitesDetailsBoxModifyProfileMutation, { data, loading, error }] = useOrganisationWebsitesDetailsBox_ModifyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationWebsitesDetailsBox_ModifyProfileMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationWebsitesDetailsBox_ModifyProfileMutation, OrganisationWebsitesDetailsBox_ModifyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationWebsitesDetailsBox_ModifyProfileMutation, OrganisationWebsitesDetailsBox_ModifyProfileMutationVariables>(OrganisationWebsitesDetailsBox_ModifyProfileDocument, options);
      }
export type OrganisationWebsitesDetailsBox_ModifyProfileMutationHookResult = ReturnType<typeof useOrganisationWebsitesDetailsBox_ModifyProfileMutation>;
export type OrganisationWebsitesDetailsBox_ModifyProfileMutationResult = Apollo.MutationResult<OrganisationWebsitesDetailsBox_ModifyProfileMutation>;
export type OrganisationWebsitesDetailsBox_ModifyProfileMutationOptions = Apollo.BaseMutationOptions<OrganisationWebsitesDetailsBox_ModifyProfileMutation, OrganisationWebsitesDetailsBox_ModifyProfileMutationVariables>;